import React from 'react';
import SMConst from 'lib/SMConst';
import SMFormSelectBox from 'components/dashboard/form/SMFormSelectBox';
import SMCalendarSelectBox from 'components/dashboard/calendar/SMCalendarSelectBox';
import SMPlanHelper from 'components/helpers/SMPlanHelper';

class SMORoomCalendarHeaderView extends React.Component {

  todayDidClick(e) {
    e.preventDefault();

    if (this.props.delegate && typeof this.props.delegate.calendarSelectBoxValueDidChange === 'function'){
      this.props.delegate.calendarSelectBoxValueDidChange(
        this.props.today.getFullYear(), this.props.today.getMonth());
    }
  }

  nextMonthDidClick(e) {
    e.preventDefault();

    if (this.props.delegate && typeof this.props.delegate.calendarSelectBoxValueDidChange === 'function') {
      const date = new Date(this.props.year, this.props.month, 1);
      date.setMonth(date.getMonth() + 1);
      this.props.delegate.calendarSelectBoxValueDidChange(
        date.getFullYear(), date.getMonth());
    }
  }

  prevMonthDidClick(e) {
    e.preventDefault();

    if (this.props.delegate && typeof this.props.delegate.calendarSelectBoxValueDidChange === 'function') {
      const date = new Date(this.props.year, this.props.month, 1);
      date.setMonth(date.getMonth() - 1);
      this.props.delegate.calendarSelectBoxValueDidChange(
        date.getFullYear(), date.getMonth());
    }
  }

  changeEditStyleDidClick(e) {
    e.preventDefault();

    if (this.props.delegate && typeof this.props.delegate.toggleEditStyle === 'function') {
      this.props.delegate.toggleEditStyle();
    }
  }

  addListItemDidClick(e) {
    e.preventDefault();

    if (this.props.delegate && typeof this.props.delegate.addListItemDidClick === 'function') {
      this.props.delegate.addListItemDidClick(e);
    }
  }

  selectBoxDidChangeValue(e) {
    if (e.currentTarget.name == 'calendar_type') {
      this.props.delegate.priceSelectDidChange(e.currentTarget.value);
    }
  }

  renderSelector() {
    if (this.props.selectedCalendar != undefined) {
      let items = [{label: '利用可否', value:SMConst.CalendarType.Availability}];
      if (this.props.plan.rent_type == SMConst.RentType.DayTime) {
        if (SMPlanHelper.hasDailyPrice(this.props.plan)) items.push({label: '終日価格', value: SMConst.CalendarType.DailyPrice});
        if (SMPlanHelper.hasHourlyPrice(this.props.plan)) items.push({label: '時間価格', value: SMConst.CalendarType.HourlyPrice});
      } else if (this.props.plan.rent_type == SMConst.RentType.Stay) {
        items.push({label: '宿泊価格', value: SMConst.CalendarType.StayPrice});
      }

      return(
        <span className="form-select__inner calendar-header__select mr10">
          <label className="form-select__s">
            <SMFormSelectBox name='calendar_type'
              items={items}
              selectedValue={this.props.selectedCalendar}
              delegate={this}
              options={{className:'w140'}} />
          </label>
        </span>
      );
    } else {
      return null;
    }
  }

  renderCalendarHeader() {
    let monthIterator = new Date(this.props.today.getTime());
    let selectableMonths = [];
    const ymDelimiter = ',';

    // 1月前から表示するため1引く
    monthIterator.setDate(1); //月末付近で8/31 + 1.month = 9/31 = 10/1と繰り上がらないように日付に1を設定する
    monthIterator.setMonth(monthIterator.getMonth() - 1);
    for (var i=0; i < 12; i++) {
      selectableMonths.push({value: monthIterator.getFullYear().toString()+ymDelimiter+monthIterator.getMonth().toString(),
                  label: I18n.l('date.ym_space', new Date(monthIterator.getFullYear(), monthIterator.getMonth(), 1))});
      monthIterator.setMonth(monthIterator.getMonth() + 1);
    }

    return(
      <div className="calendar-header">
        <h2 className="mb15 mr15 fl">
          {this.renderSelector()}
          <span className="form-select__inner calendar-header__select">
            <label className="form-select__s">
              <SMCalendarSelectBox
                name="ym"
                items={selectableMonths}
                selectedValue={this.props.year.toString()+ymDelimiter+this.props.month.toString()}
                delegate={this.props.delegate}
                options={{className:'w140'}} />
            </label>
          </span>
        </h2>
        <p className="fl">
          <a href="#" className="button-blue calendar-header__button calendar-header__button-arrow" onClick={this.prevMonthDidClick.bind(this)}><i className="fa fa-angle-left"></i></a>
          <a href="#" className="button-blue calendar-header__button" onClick={this.todayDidClick.bind(this)}>今日</a>
          <a href="#" className="button-blue calendar-header__button calendar-header__button-arrow" onClick={this.nextMonthDidClick.bind(this)}><i className="fa fa-angle-right"></i></a>
        </p>
        <p className="fr mt7">
          <a href="#" onClick={this.changeEditStyleDidClick.bind(this)} className="link-hover-border mr10">一覧を表示</a>
        </p>
      </div>
    );
  }

  renderListHeader() {
    return(
      <div className="calendar-header mb10">
        <p className="fr mt10">
          <a href="#" onClick={this.changeEditStyleDidClick.bind(this)} className="link-hover-border mr10">カレンダーを表示</a>
        </p>
        <p>
          {this.renderSelector()} を設定
          <a href="#" onClick={this.addListItemDidClick.bind(this)} className="link-hover-border mr150 ml20">新規追加</a>
        </p>
      </div>
    );
  }

  render() {
    if (this.props.editStyle == 'calendar') {
      return this.renderCalendarHeader();
    } else {
      return this.renderListHeader();
    }
  }
}
export default SMORoomCalendarHeaderView;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/rooms/fragments/SMORoomCalendarHeaderView.jsx